const Paper = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius * 2.5,
    }),
  },
};

export default Paper;
